var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCafeteria({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.49999H14.75V22.49H16.25V14.99H18.5C18.9 14.99 19.28 14.83 19.56 14.55C19.84 14.27 20 13.89 20 13.49V5.98999C20.02 5.38999 19.92 4.79999 19.7 4.23999C19.48 3.67999 19.15 3.17999 18.73 2.75999C18.31 2.33999 17.8 2.00999 17.25 1.78999C16.69 1.56999 16.1 1.46999 15.5 1.48999V1.49999ZM18.49 13.5H16.24V3.06999C18.4 3.48999 18.49 5.71999 18.49 5.99999V13.5Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1.5H5.75V10.19H7.25V1.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 1.5H9.49V11.25H3.5V1.5H2V11.25C2 12.08 2.67 12.75 3.5 12.75H5.75V22.5H7.25V12.75H9.49C10.32 12.75 10.99 12.08 10.99 11.25V1.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCafeteria);
export default __webpack_public_path__ + "static/media/ic-cafeteria.1bdfbe65e54fc663a096ccb0ba450f27.svg";
export { ForwardRef as ReactComponent };